module.exports = __webpack_public_path__ + "static/img/cancel_not_gif.2bc9fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cancel_not_gif.png
// module id = mcul
// module chunks = 109